import { identity } from 'ramda';

export const formatExtraDefaultValues = identity;

export const formatExtraDataBeforeSubmit = identity;
